




















































































































































































































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { Acompanhamento } from '../../../../back/src/types';
import { Internacao } from '../../../../back/src/entity/Internacao';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { Usuario } from '../../../../back/src/entity/Usuario';

import Carregando from '../../components/Carregando.vue';
import CustomDialog from '../../components/CustomDialog.vue';
import TheInternacoesNovaForm from '../../components/internacoes/TheInternacoesNovaForm.vue';
import ThePacientesResumo from '../../components/pacientes/ThePacientesResumo.vue';
import ThePacientesObservacoesAlert from '../../components/pacientes/ThePacientesObservacoesAlert.vue';
import ThePacientesGestantesPreNatalTabela from '../../components/pacientes/ThePacientesGestantesPreNatalTabela.vue';
import { gruposIds } from '../../utils/constants';

export default Vue.extend({
  name: 'GestacoesIndex',
  components: {
    Carregando,
    CustomDialog,
    TheInternacoesNovaForm,
    ThePacientesResumo,
    ThePacientesObservacoesAlert,
    ThePacientesGestantesPreNatalTabela,
  },
  data() {
    return {
      loading: {
        usuarios: true,
        pacientes: true,
      },
      tab: 0,
      pacientes: [],
      usuarios: [],
      filterResponsavelParticular: null,
      dialogInternacao: false,
      dialogResumoPaciente: false,
      pacienteSelecionada: null,
    };
  },
  computed: {
    pacientesColetivo() {
      return _.filter(
        this.pacientes as Paciente[],
        paciente => paciente.acompanhamento === Acompanhamento.COLETIVO,
      );
    },
    pacientesCasaDeParto() {
      return _.filter(
        this.pacientes as Paciente[],
        paciente => paciente.acompanhamento === Acompanhamento.CASA_DE_PARTO,
      );
    },
    pacientesParticular() {
      return _.filter(
        this.pacientes as Paciente[],
        paciente => (
          paciente.acompanhamento === Acompanhamento.PARTICULAR
          && (this.filterResponsavelParticular
            ? paciente.responsavel_id === this.filterResponsavelParticular
            : true
          )
        ),
      );
    },
    usuariosItens() {
      return _.orderBy(
        _.map(_.filter(this.usuarios, usuario => !usuario.email.includes('@kemiocode')),
          usuario => ({ value: usuario.id, text: usuario.nome })),
        ['text'],
      );
    },
    thePacientesGestantesPreNatalTabelaColetivo(): Vue & { alterarResponsavel: () => void } {
      return this.$refs.thePacientesGestantesPreNatalTabelaColetivo as Vue & {
        alterarResponsavel: () => void,
      };
    },
    thePacientesGestantesPreNatalTabelaCasaDeParto(): Vue & { alterarResponsavel: () => void } {
      return this.$refs.thePacientesGestantesPreNatalTabelaCasaDeParto as Vue & {
        alterarResponsavel: () => void,
      };
    },
  },
  mounted() {
    this.buscaPacientesGestantes();
    this.buscaUsuarios();
  },
  methods: {
    internacaoAgendadaId(internacoes: Internacao[]) {
      const internacaoAgendada = _.find(
        internacoes,
        internacao => (!internacao.datetime_internacao
          && !internacao.data_alta
          && !internacao.cancelled
        ),
      );
      return _.get(internacaoAgendada, 'id', null);
    },
    internacaoAtivaId(internacoes: Internacao[]) {
      const internacaoAtiva = _.find(
        internacoes,
        internacao => (!!internacao.datetime_internacao
          && !internacao.data_alta
          && !internacao.cancelled
        ),
      );
      return _.get(internacaoAtiva, 'id', null);
    },
    novaInternacao(internacao: Internacao) {
      this.$router.push({
        name: 'InternacoesVer',
        params: { internacaoId: internacao.id },
      });
    },
    verResumoPaciente(gestante) {
      this.pacienteSelecionada = gestante.paciente;
      this.dadosGestanteSelecionada = gestante;
      this.dialogResumoPaciente = true;
    },
    alterarResponsavelColetivo() {
      this.thePacientesGestantesPreNatalTabelaColetivo.alterarResponsavel();
    },
    alterarResponsavelCasaDeParto() {
      this.thePacientesGestantesPreNatalTabelaCasaDeParto.alterarResponsavel();
    },
    atualizaResponsavel(dados: { responsavelId: number, gestacoesIds: number[] }) {
      _.forEach(
        this.pacientes,
        (paciente, index) => {
          if (dados.gestacoesIds.includes(_.get(paciente, 'gestacao_atual.id', null))) {
            this.$set(this.pacientes[index], 'gestacao_atual.responsavel_id', dados.responsavelId);
            this.$set(
              this.pacientes[index],
              'gestacao_atual.responsavel',
              _.find(this.usuarios, usuario => usuario.id === dados.responsavelId),
            );
          }
        },
      );
    },
    async buscaPacientesGestantes() {
      this.loading.pacientes = true;
      try {
        const response = await Requester.paciente.pacientesGestantes();
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.pacientes = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.pacientes = false;
      }
    },
    async buscaUsuarios() {
      this.loading.usuarios = true;
      try {
        const response = await Requester.usuario.usuarios({
          grupo_id: [
            gruposIds.MÉDICAS,
            gruposIds.DIREÇÃO,
            gruposIds.OBSTETRIZES,
          ],
          ativo: 'true',
        });
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.usuarios = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.usuarios = false;
      }
    },
  },
});
